
import brightripplelogo from "./brightripplelogo.png";
import brightripplelogo3 from "./brightripplelogo3.png";
import quotes from "./quotes.svg";
import menu from "./menu.svg";
import close from "./close.svg";
import apple from "./apple.svg";
import arrowUp from "./arrow-up.svg";
import facebook from "./facebook.svg";
import instagram from "./instagram.svg";
import linkedin from "./linkedin.svg";
import greenCheck from "./green-check.svg";

// Use the Twitter image uploaded to the public folder. This keeps the same
// `twitter` export name so existing imports don't need to change.
const twitter = process.env.PUBLIC_URL + "/twittericon.jpg";

export {
  arrowUp,
  brightripplelogo3,
  brightripplelogo,
  quotes,
  menu,
  close,
  apple,
  facebook,
  instagram,
  linkedin,
  twitter,
  greenCheck,
};
